<template>
  <div class="search">
    <Row :gutter="4">
      <!-- 选择公司 -->
      <div v-if="company == 1">
        <Col span="4">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('alarm_contact.selectByCompany')"
            :transfer="true"
            @on-change="searchCompany"
          >
            <Option value=" " selected>{{
              $t("alarm_contact.allType")
            }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
      </div>
      <Col span="4">
        <Input
          search
          v-model="name"
          :placeholder="$t('alarm_contact.searchByRobotName')"
          @on-search="searchName()"
        />
      </Col>
      <Col span="4">
        <Button
          type="primary"
          v-hasPermission="[
            'alarm_contact:AlarmContactWechatRobot:createOrUpdate'
          ]"
          @click="addOrUpdateHandle"
          >{{ $t("alarm_contact.add") }}</Button
        >
      </Col>
    </Row>
    <add-enterprise-wechat-robot
      v-if="addOrUpdateVisible"
      ref="addOrUpdate"
    ></add-enterprise-wechat-robot>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../utils/cookieUtil.js";
import AddEnterpriseWechatRobot from "../enterprise_wechat_robot/AddEnterpriseWechatRobot";
import TableEnterpriseWechatRobot from "../enterprise_wechat_robot/TableEnterpriseWechatRobot";
var tableEnterpriseWechatRobot = TableEnterpriseWechatRobot;
export default {
  name: "EnterpriseWechatRobotSearch",
  components: {
    AddEnterpriseWechatRobot
  },
  data() {
    return {
      company: getCookie(global.companyId),
      companyId: "",
      companyList: [],
      name: "",
      addOrUpdateVisible: false
    };
  },
  mounted: function() {
    if (this.company == 1) {
      this.getCompanyDropDownBox();
    }
  },
  methods: {
    // 添加
    /**********************************************************/
    addOrUpdateHandle: function() {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init();
      });
    },
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    },
    // 按公司搜索
    searchCompany: function() {
      // 在需要传递参数的组件中，定义一个emit发送需要传递的值，键名可以自己定义（可以为对象）
      eventBus.$emit("userCompanyId", this.companyId);
      tableEnterpriseWechatRobot.methods.showAll();
    },
    searchName: function() {
      eventBus.$emit("name", this.name);
      tableEnterpriseWechatRobot.methods.showAll();
    }
  }
};
</script>
<style scoped>
.search {
  height: 51px;
}
</style>



// WEBPACK FOOTER //
// src/components/alarm_contact/enterprise_wechat_robot/EnterpriseWechatRobotSearch.vue